import React from "react";
import { Badge, Fab, Tooltip } from "@mui/material";
import SmartToyRoundedIcon from "@mui/icons-material/SmartToyRounded";

export default function AssistantLauncher({
  onClick,
  disabled,
  hidden,
  hasStreamingMessage,
}) {
  if (hidden) return null;

  return (
    <Tooltip title="Abrir asistente">
      <span
        data-ai-exclude-capture="true"
        style={{
          position: "fixed",
          right: 24,
          bottom: 24,
          zIndex: 1500,
        }}
      >
        <Badge
          color="warning"
          variant={hasStreamingMessage ? "dot" : "standard"}
          overlap="circular"
          sx={{
            "& .MuiBadge-badge": {
              boxShadow: "0 0 0 4px rgba(10,14,22,0.85)",
            },
          }}
        >
          <Fab
            onClick={onClick}
            disabled={disabled}
            sx={{
              width: 60,
              height: 60,
              background:
                "linear-gradient(135deg, rgba(232,78,14,1) 0%, rgba(255,139,49,0.96) 100%)",
              color: "#fff",
              boxShadow: hasStreamingMessage
                ? "0 0 0 10px rgba(232,78,14,0.12), 0 20px 34px rgba(232,78,14,0.34)"
                : "0 18px 30px rgba(232,78,14,0.28)",
              transition: "transform 180ms ease, box-shadow 180ms ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 22px 38px rgba(232,78,14,0.36)",
              },
            }}
          >
            <SmartToyRoundedIcon sx={{ fontSize: 30 }} />
          </Fab>
        </Badge>
      </span>
    </Tooltip>
  );
}
